import React, { useEffect, useRef, useState } from 'react';
import './ViolationPage.scss';
import { useDispatch, useSelector, useStore } from 'react-redux';
import { useForm } from 'react-hook-form';
import { useIntl } from 'react-intl';
import fileDownload from 'js-file-download';
import {
  getFilterData,
  getJsonFromStorage,
  getPaginationOpts, getResponseError,
  responseLogWithNotification,
  useUpdatePeriod,
} from '../../../utils/utils';
import { getSystemData } from '../../System/reducer';
import Loader from '../../../components/base/Loader/Loader';
import { getViolationData } from '../reducer';
import Pagination from '../../../components/base/Pagination/Pagination';
import CustomizedGrid from '../../../components/base/Grid/CustomizedGrid';
import { VIOLATIONS_MODULE } from '../../../configs/moduleNames';
import {
  exportWorkControl,
  loadViolationsList,
} from '../actions';
import FilterRow from '../../../components/base/FilterRow/FilterRow';
import FieldDTO from '../../../components/fields/Abstract/FieldDTO';
import { Icons, Button } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import TextInput from '../../../components/fields/TextInput/TextInput';
import TooltipWithPortal from '../../../components/base/Tooltip/TooltipWithPortal';
import { POPUP_LIST_NAME } from '../../../configs';
import { addGlobalPopUpWrapper } from '../../InformationScreenWrapper/actions';
import getDefaultSort from '../../../utils/getDefaultSort';
import {
  getLegalEntityName, userFIOFormatter,
} from '../../../utils/formatters';
import TabMenu from '../../../components/base/TabMenu/TabMenu';
import FilterModal from '../../FilterTemplate/components/FilterModal';
import { PAGE_TYPE } from '../../FilterTemplate/components/filter-settings';
import { violationColumns } from './violationColumns';
import notificationDecorator, { errorNotification } from '../../Notifications/notificationDecorator';
import ExportInterface from '../../System/components/ExportInterface';

export default function ViolationsPage() {
  const blockRef = useRef(null);
  const dispatch = useDispatch();
  const store = useStore();
  const { updatePeriod } = useSelector(getSystemData);
  const {
    violationList,
    violationListMeta,
    loadingViolationList,
  } = useSelector(getViolationData);
  const [selectedTab, setSelectedTab] = useState('driver');
  const filterName = 'violation-filter';
  const [isOpenFilter, setOpenFilter] = useState(false);
  const { formatMessage } = useIntl();
  const loadData = opts => {
    const paginationOpts = getPaginationOpts(store.getState()[VIOLATIONS_MODULE].violationListMeta, opts);
    const requestData = {
      ...paginationOpts,
      filter: { ...getValues(), type: [selectedTab] },
      sort,
    };
    const p1 = dispatch(loadViolationsList(requestData)).catch(responseLogWithNotification);
    return Promise.all([p1]);
  };
  const [setPeriod] = useUpdatePeriod(loadData, updatePeriod);
  useEffect(() => setPeriod(updatePeriod), [updatePeriod]);

  useEffect(() => {
    loadData();
  }, [selectedTab]);

  const rowClassFormatter = item => {
    const classes = ['clickable-table-row'];

    return classes.join(' ');
  };

  const conditionalColumn = selectedTab === 'driver' ? {
    dataField: 'driver',
    text: 'Водитель',
    formatter: item => userFIOFormatter({ last_name: item?.driver_last_name, first_name: item?.driver_first_name, middle_name: item?.driver_middle_name }),
    disableSort: true,
  } : {
    dataField: 'applicant',
    text: 'Перевозчик',
    formatter: getLegalEntityName,
    disableSort: true,
  };

  const moreFormatter = (_, item) => (
    <TooltipWithPortal
      content={<Icons customIcon icon="more-vert" className="more-vert" />}
      classNamePortal="more-actions"
      tooltipContent={(
        <div className="more-wrapper" />
      )}
      classNameWrapper="more-tooltip-wrapper"
      className="more-tooltip"
    />
  );

  useEffect(() => reset(getFilterData(filterName, {})), []);
  const {
    getValues, watch, control, reset,
  } = useForm({ defaultValues: getJsonFromStorage('violation-page-filter', {}) });

  useEffect(() => {
    const subscription = watch(values => {
      localStorage.setItem(filterName, JSON.stringify(values));
      loadData({ page: 1 });
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  const [sort, setSort] = useState(getDefaultSort(violationColumns));

  const changeSort = fieldName => {
    if (sort && (sort === fieldName || sort === `-${fieldName}`)) {
      if (sort === `-${fieldName}`) {
        setSort(fieldName);
      } else if (sort === fieldName) {
        setSort('');
      }
    } else {
      setSort(`-${fieldName}`);
    }
  };

  useEffect(() => { loadData(); }, [sort]);
  return (
    <div className="page violation-page">
      <Loader global loading={loadingViolationList} />
      <div className="page-title">
        <div className="title-text">{formatMessage({ id: 'menu.violations' })}</div>
        <TabMenu options={[{ value: 'applicant', label: 'Штрафы перевозчиков' }, { value: 'driver', label: 'Штрафы водителей' }]} onSelectOptions={i => setSelectedTab(i.value)} selectedTab={selectedTab} />
        <FilterRow>
          <FieldDTO
            control={control}
            component={TextInput}
            dtoObject={{
              name: 'search',
              type: String,
              labelKey: 'search',
            }}
            className="no-border"
            inputBefore={(
              <div className="search-wrapper">
                <Icons customIcon className="search" width={24} height={24} icon="search" />
              </div>
            )}
          />
          <div className="filter-sep" />
          <ExportInterface page="violations" exporter="violations" getValues={getValues} />
          <div className="filter-sep" />
          <Button variant="second" onClick={() => setOpenFilter(true)}>
            <Icons customIcon className="file-download" width={24} height={24} icon="filter" />
          </Button>
          {isOpenFilter
            ? (
              <FilterModal
                control={control}
                onClose={() => setOpenFilter(false)}
                getValues={getValues}
                reset={reset}
                defaultValues={{}}
                page={PAGE_TYPE.VIOLATIONS}
              />
            )
            : null}
        </FilterRow>
      </div>
      <div className="page-content-wrapper">
        <div className="page-content" ref={blockRef}>
          <div className="grid-wrapper frame">
            <div className="custom-scroll-theme sticky-table-wrapper">
              <CustomizedGrid
                data={violationList}
                rowClassFormatter={rowClassFormatter}
                columns={[conditionalColumn, ...violationColumns]}
                name="violations-list"
                changeSort={changeSort}
                sort={sort}
                onDoubleClickByRow={item => {
                  dispatch((addGlobalPopUpWrapper({ window: POPUP_LIST_NAME.VIOLATION_DETAIL, id: item?.id })));
                }}
                settingsFormatter={moreFormatter}
              />
            </div>
          </div>
          <Pagination meta={violationListMeta} list={violationList} handleChangeMeta={loadData} />
        </div>
      </div>
    </div>
  );
}
